var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("CLIENTES")]),
      _vm._v(" "),
      _c("div", { staticClass: "switch-group mb-20" }, [
        _c(
          "div",
          {
            staticClass: "switch",
            class: { active: _vm.type === "legals" },
            on: {
              click: function($event) {
                return _vm.setType("legals")
              }
            }
          },
          [_vm._v("\n      B2B\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "switch",
            class: { active: _vm.type === "physicals" },
            on: {
              click: function($event) {
                return _vm.setType("physicals")
              }
            }
          },
          [_vm._v("\n      B2C\n    ")]
        )
      ]),
      _vm._v(" "),
      _vm.type === "physicals" ? _c("physicals") : _c("legals")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-749a7478", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-749a7478","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customers/Index.vue
// module id = null
// module chunks = 